import ApiBudgety from '@/api/apiBudgety'

export const tipoMovimientoService = {
  getTipoMovimiento,
}

async function getTipoMovimiento() {
  return await ApiBudgety.get('TipoMovimiento/GetAll')
}
